module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAMCAMAAACz+6aNAAAAYFBMVEVnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGgAAABnaGjHZ8Q0AAAAH3RSTlPB3Poy6uXTyCgV89/XuIZ7d1dMR5mOdGMbrqWbcDcAtEYLNAAAAHRJREFUCNddzkcOhDAQRNEeZwPOpIl1/1uOQbaE+MunlroItxjB5Qm9dRtGgiy8U7Av9iBAZK7O+2ifQJVK6asqBOPQBHo3JNdfRJexpLQbHvnSZOJFwG8Ks11OUSaL9uttPatCH4neHI49DJcGSHKaLmnt/39VEE1nQ1VXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/gw_mail_icon.png
// module id = 11
// module chunks = 1